// Compare Popup Custom JavaScript
(function() {
  'use strict';
  
  // 应用sticky效果 - 仅桌面端
  function applyStickyStyles(element) {
    if (!element) return;
    
    // 检查是table还是div结构
    var isTable = element.tagName.toLowerCase() === 'table';
    var isDiv = element.classList.contains('comparison-table');
    
    if (!isTable && !isDiv) return;
    
    // 仅处理桌面端
    if (isDiv) {
      initDesktopCompareDiv(element);
    }
  }
  
  // 将函数暴露到全局作用域，供手机端调用
  window.applyStickyStyles = applyStickyStyles;
  
  // 桌面端处理div结构
  function initDesktopCompareDiv(divTable) {
    // 仅在桌面端执行
    if (window.innerWidth <= 768) {
      return;
    }
    
    // 修复父容器overflow
    var parent = divTable.closest('[class*="modal"], [class*="popup"], [class*="overlay"]');
    if (parent) {
      parent.style.overflow = 'visible';
    }
    
    // 弹窗标题栏已经有 Compare Options，这里不再往内容区再插一行。

    // 创建滚动容器
    var scrollContainer = document.createElement('div');
    scrollContainer.className = 'table-scroll-container';
    scrollContainer.style.maxHeight = 'calc(90vh - 120px)';
    scrollContainer.style.overflowY = 'auto';
    /* 多列套装时可左右滚动；少列时无溢出则不出现横条 */
    scrollContainer.style.overflowX = 'auto';
    scrollContainer.style.padding = '0';
    scrollContainer.style.background = '#fff';
    scrollContainer.style.borderRadius = '8px';
    
    // 包装表格
    divTable.parentNode.insertBefore(scrollContainer, divTable);
    scrollContainer.appendChild(divTable);
    
    // 应用header sticky
    var headerRow = divTable.querySelector('.table-row.header');
    if (headerRow) {
      headerRow.style.position = 'sticky';
      headerRow.style.top = '0';
      headerRow.style.zIndex = '10';
      headerRow.style.backgroundColor = '#f8f9fa';
      headerRow.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
    }
    
    // 只应用第二行（产品图片行）sticky
    var rows = divTable.querySelectorAll('.table-row');
    
    // 第二行（产品图片行）- 不固定，仅设置样式
    if (rows.length >= 2) {
      rows[1].style.backgroundColor = '#fff';
      
      // 修复产品图片大小 - 改为200px，使用最高质量渲染
      var images = rows[1].querySelectorAll('img');
      images.forEach(function(img) {
        img.style.setProperty('width', '200px', 'important');
        img.style.setProperty('height', '200px', 'important');
        img.style.setProperty('max-width', '200px', 'important');
        img.style.setProperty('max-height', '200px', 'important');
        img.style.objectFit = 'contain';
        img.style.borderRadius = '0';
        img.style.boxShadow = 'none';
        img.style.border = 'none';
        // 高质量图片渲染 - 完全禁用GPU加速
        img.style.imageRendering = 'auto';
        img.style.imageRendering = 'high-quality';
        img.style.transform = 'none';
        img.style.willChange = 'auto';
        img.style.backfaceVisibility = 'visible';
      });
    }
    
    // 第三行（价格行）- 强制移除sticky，确保不固定
    if (rows.length >= 3) {
      rows[2].style.setProperty('position', 'static', 'important');
      rows[2].style.setProperty('top', 'auto', 'important');
      rows[2].style.setProperty('z-index', 'auto', 'important');
      rows[2].style.setProperty('background-color', 'transparent', 'important');
      rows[2].style.setProperty('box-shadow', 'none', 'important');
    }
    
    // 确保其他行也不固定，并设置参数行自适应高度
    for (var i = 3; i < rows.length; i++) {
      rows[i].style.setProperty('position', 'static', 'important');
      rows[i].style.setProperty('top', 'auto', 'important');
      rows[i].style.setProperty('z-index', 'auto', 'important');
      rows[i].style.setProperty('background-color', 'transparent', 'important');
      rows[i].style.setProperty('box-shadow', 'none', 'important');
      
      // 设置参数行自适应高度，短文字一行，长文字最多两行
      if (i >= 4) { // 从第4行开始是参数行
        rows[i].style.setProperty('min-height', '48px', 'important');
        rows[i].style.setProperty('height', 'auto', 'important');
      }
    }

    // 横滑固定前两列：按第1列实际宽度设置第2列 left（对齐官方站对照列）
    function updateStickyColumnOffset() {
      var firstCell = divTable.querySelector('.table-row .cell:first-child');
      if (!firstCell) return;
      var width = Math.ceil(firstCell.getBoundingClientRect().width);
      if (width > 0) {
        divTable.style.setProperty('--compare-sticky-col1', width + 'px');
      }
    }

    requestAnimationFrame(function() {
      updateStickyColumnOffset();
      var allImages = divTable.querySelectorAll('img');
      for (var imgIndex = 0; imgIndex < allImages.length; imgIndex++) {
        var imageEl = allImages[imgIndex];
        if (!imageEl.complete) {
          imageEl.addEventListener('load', updateStickyColumnOffset, { once: true });
        }
      }
    });
  }
  
  // 手机端处理 - 已删除，将在新文件中重新实现
  
  // 手机端相关函数 - 已删除，将在新文件中重新实现
  
  // 强制应用交替行颜色 - 暂时注释掉
  /*
  function applyAlternatingRowColors(element) {
    var rows = element.querySelectorAll('.table-row');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var cells = row.querySelectorAll('.cell');
      
      // 跳过表头、产品图片行、价格行
      if (row.classList.contains('header') || 
          row === rows[1] || 
          row === rows[2]) {
        continue;
      }
      
      // 计算行索引（从参数行开始）
      var rowIndex = i - 3; // 减去表头、图片行、价格行
      
      if (rowIndex >= 0) {
        if (rowIndex % 2 === 0) {
          // 偶数行 - 灰色
          row.style.backgroundColor = '#f8f9fa';
          for (var j = 0; j < cells.length; j++) {
            cells[j].style.backgroundColor = '#f8f9fa';
          }
        } else {
          // 奇数行 - 白色
          row.style.backgroundColor = '#fff';
          for (var j = 0; j < cells.length; j++) {
            cells[j].style.backgroundColor = '#fff';
          }
        }
      }
    }
  }
  */
  
  // 主函数
  function init() {
    // 监听DOM变化
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          // 查找弹窗中的div结构
          var divTables = document.querySelectorAll('.comparison-table');
          
          divTables.forEach(function(divTable) {
            // 检查div表格是否在弹窗中
            var popup = divTable.closest('[class*="modal"], [class*="popup"], [class*="overlay"]');
            if (popup && popup.style.display !== 'none' && !divTable.dataset.stickyApplied) {
              divTable.dataset.stickyApplied = 'true';
              applyStickyStyles(divTable);
            }
          });
        }
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    // 定期检查
    var checkInterval = setInterval(function() {
      var divTables = document.querySelectorAll('.comparison-table');
      
      divTables.forEach(function(divTable) {
        var popup = divTable.closest('[class*="modal"], [class*="popup"], [class*="overlay"]');
        if (popup && popup.style.display !== 'none' && !divTable.dataset.stickyApplied) {
          divTable.dataset.stickyApplied = 'true';
          applyStickyStyles(divTable);
        }
      });
    }, 1000);
    
    // 10秒后停止检查
    setTimeout(function() {
      clearInterval(checkInterval);
    }, 10000);
  }
  
  // 页面加载完成后执行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();